"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default2 = exports.default = {
  name: 'Select',
  model: {
    prop: 'selectValue'
  },
  props: {
    label: {
      type: String,
      default: '选择器'
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    overlay: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    safeAreaInsetBottom: {
      type: Boolean,
      default: false
    },
    selectValue: {
      type: String
    },
    type: {
      type: String
    }
  },
  data: function data() {
    return {
      value: this.selectValue,
      showPicker: false
    };
  },
  watch: {
    selectValue: function selectValue(newVal) {
      this.value = newVal;
    },
    value: function value(newVal) {
      this.$emit('input', newVal);
    }
  },
  methods: {
    handleConfirmSelect: function handleConfirmSelect(value) {
      this.value = value;
      this.showPicker = false;
      this.$emit('selectConfirm', value, this.type);
    }
  }
};